import React from "react";
import "./scss/restotan.scss";
import { Footer, Header, Section } from "./components";

function App() {
  return (
    <div className="App">
      <div className="page">
        <Header></Header>
        <Section></Section>
      </div>
      <Footer></Footer>
    </div>
  );
}

export default App;
